import * as React from 'react';
import { getCustomColumnsModalDispatchProps, getCustomColumnsModalStateProps } from './customColumnsModalUtils';
import { connect } from 'react-redux';
import CustomColumnsModalPure from 'src/design-system/components/organisms/CustomColumnsModalPure/CustomColumnsModalPure';

const CustomColumnsModal = (props) => {
  const {
    customColumnsModalStateProps,
    customColumnsModalActions,
    onModalSubmit,
    showFiltersAndActions,
    hideActions,
  } = props;

  const { updatesList } = customColumnsModalStateProps || {};

  const {
    setColumns,
    setCustomFilters,
    setCustomActions,
    setCurrentCustomFilters,
    setCustomUpdates,
    reloadBucket,
  } = customColumnsModalActions;

  const handleModalSubmit = async ({
    columns,
    updates,
    customActions,
    customHeaders,
    customFilters,
    enableUpdateForAll,
  }) => {
    if (onModalSubmit) {
      onModalSubmit(columns, customActions, customHeaders, updates, customFilters);
    } else {
      await setColumns(columns);
      if (showFiltersAndActions) {
        setCustomFilters(customFilters);
        setCurrentCustomFilters(customFilters);
        !hideActions && setCustomActions(customActions);
        Array.isArray(updatesList) && updatesList.length && setCustomUpdates({ updates, enableUpdateForAll });
      }
      if (reloadBucket) {
        reloadBucket();
      }
    }
  }

  return (
    <CustomColumnsModalPure
      {...props}
      {...customColumnsModalStateProps}
      onModalSubmit={handleModalSubmit}
      showEnableUpdatesForAll={!onModalSubmit}
    />
  )
}

const mapStateToProps = ({ genericConsignmentReducer, masterData }, ownProps) => {
  const { bucket, viewType } = ownProps;
  const currentViewReducer = genericConsignmentReducer[viewType];
  return {
    customColumnsModalStateProps: getCustomColumnsModalStateProps(masterData, viewType, bucket, ownProps),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { viewType, bucket } = ownProps;
  return {
    customColumnsModalActions: getCustomColumnsModalDispatchProps(dispatch, viewType, bucket),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomColumnsModal);
